/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface EntiteCentreSearch
 */
export interface EntiteCentreSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof EntiteCentreSearch
     */
    nom?: TextSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof EntiteCentreSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof EntiteCentreSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof EntiteCentreSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EntiteCentreSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof EntiteCentreSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof EntiteCentreSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the EntiteCentreSearch interface.
 */
export function instanceOfEntiteCentreSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EntiteCentreSearchFromJSON(json: any): EntiteCentreSearch {
    return EntiteCentreSearchFromJSONTyped(json, false);
}

export function EntiteCentreSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntiteCentreSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nom': !exists(json, 'nom') ? undefined : TextSearchFromJSON(json['nom']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function EntiteCentreSearchToJSON(value?: EntiteCentreSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nom': TextSearchToJSON(value.nom),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

